<fn-modal-header class="modal-header">
    <h5 class="modal-title" mat-dialog-title>Disable</h5>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </fn-modal-header>
  <mat-dialog-content class="p-15">
    <div class="row forwardMdl">
       <div class="col-12  mb-10">
        <span class="heading">Set Disable Date and Time (UpTo 24 Hrs): </span> 
        <span class="description">
                <fn-date-time-picker (callback)="changeDate($event)" ></fn-date-time-picker>
        </span>      
      </div>
      </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
        <div class="col-6 text-left">
        <button class="btn btn-primary float-left btn-round" (click)="disable()">
          Disable
        </button>
      </div>
    </div>
  </mat-dialog-actions>
  